import { IndexedDBCache } from "finhelper";

export default class CacheHelper {
    static SERVER_DATA = "server";

    /**
     * Подставляет params в pattern (заменяет {key} на params[key])
     */
    static generateKey = (pattern: string, params: Record<string, string | number>): string => {
        let result = pattern;
        Object.keys(params).forEach((key) => {
            result = result.replace(new RegExp(`{${key}}`, "g"), String(params[key]));
        });
        return result;
    };

    static startAgain(): void {
        IndexedDBCache.clearAll();
    }

    static clearAll(): void {
        localStorage.clear();
        IndexedDBCache.clearAll();
    }
}
